module.exports = __webpack_public_path__ + "img/award-en.69fdd223.png";